import React from "react";
import "../assets/InvoiceFragment.css";

export default function InvoiceFragment({ invoice, title}) {
  if (!invoice) {
    return <div className="last-invoice">Nessuna fattura disponibile</div>;
  }

  return (
    <div className="last-invoice ">
      <h3 className="last-invoice__title">{title}</h3>
      <p><strong className="last-invoice_element-head">Nome:</strong> {invoice.name}</p>
      <p><strong className="last-invoice_element-head">Data:</strong> {invoice.date}</p>
      <p><strong className="last-invoice_element-head">Mittente:</strong> {invoice.sender}</p>
    </div>
  );
}
